import { AxiosPromise } from 'axios';
import axios from '../../utilities/axios';
import {
  ActivateRangeParams,
  ActivateRangeResponse,
  GetPipelineModelsResponse,
  GetTestTypesResponse,
} from '.';

export const MANUFACTURED_CHIPS_ROUTES = {
  ACTIVATE: '/manufactured-chips/activate-range',
  MODELS: '/manufactured-chips/pipeline-model-get-all',
  PRODUCT: '/manufactured-chips/get-test-types',
};

export function activateRange(data: ActivateRangeParams): AxiosPromise<ActivateRangeResponse> {
  return axios.getInstance().post(MANUFACTURED_CHIPS_ROUTES.ACTIVATE, data);
}
export function getPipelineModels(): AxiosPromise<GetPipelineModelsResponse> {
  return axios.getInstance().get(MANUFACTURED_CHIPS_ROUTES.MODELS);
}

export function getTestTypes(): AxiosPromise<GetTestTypesResponse> {
  return axios.getInstance().get(MANUFACTURED_CHIPS_ROUTES.PRODUCT);
}
